import estyled from '@signal/theme/emotion'

export const HeaderWrapper = estyled.div`
  height: 100%;
`

export const NavLinkWrapper = estyled.div`
  padding: ${({ theme }) => theme.spacing(2)}px;
`
